module.exports = __webpack_public_path__ + "img/9791191432329.e400699b.jpg";